import { FormEvent, useState } from 'react'
import { Eyebrow, PageHero } from '../components/SiteShell'

type SubmitState = 'idle' | 'sending' | 'sent' | 'error'

export function ContactPage(){
  const [submitState,setSubmitState]=useState<SubmitState>('idle')
  const [feedback,setFeedback]=useState('')

  async function submit(e:FormEvent<HTMLFormElement>){
    e.preventDefault()
    const form=e.currentTarget
    const fields=new FormData(form)
    setSubmitState('sending')
    setFeedback('')

    try{
      const response=await fetch('/api/contact',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          name:fields.get('name'),
          email:fields.get('email'),
          organisation:fields.get('organisation'),
          topic:fields.get('topic'),
          message:fields.get('message'),
          website:fields.get('website'),
        }),
      })
      const result=await response.json() as {message?:string,error?:string}
      if(!response.ok) throw new Error(result.error||'We could not send your message just now.')
      setSubmitState('sent')
      setFeedback(result.message||'Thanks — your message has been sent.')
      form.reset()
    }catch(error){
      setSubmitState('error')
      setFeedback(error instanceof Error?error.message:'We could not send your message just now.')
    }
  }

  return <>
    <style>{`.contact-form select{min-height:52px;padding:16px;border:1px solid #C9D2DE;border-radius:8px;background:#FFFFFF;color:#111827;font:inherit;cursor:pointer}.contact-form select:focus{outline:2px solid rgba(22,139,255,.35);outline-offset:1px;border-color:#168BFF}.contact-honeypot{position:absolute!important;left:-10000px!important;width:1px!important;height:1px!important;overflow:hidden!important}`}</style>
    <PageHero eyebrow="Contact" title="Start a conversation." body="For research discussion, Conseqra collaboration, design partnerships or early product interest, contact Semantic Secured." />
    <section className="contact-grid">
      <form className="contact-form" onSubmit={submit}>
        <h2>Contact Semantic Secured</h2>
        <label>Name<input name="name" required maxLength={100} autoComplete="name" placeholder="Your name" /></label>
        <label>Email<input name="email" required type="email" maxLength={254} autoComplete="email" placeholder="name@company.com" /></label>
        <label>Organisation<input name="organisation" maxLength={150} autoComplete="organization" placeholder="Company or research organisation" /></label>
        <label>Topic<select name="topic" required defaultValue=""><option value="" disabled>Select a topic</option><option>Conseqra platform</option><option>Research collaboration</option><option>Partnership</option><option>Speaking or press</option><option>General enquiry</option></select></label>
        <label>Message<textarea name="message" required minLength={10} maxLength={5000} placeholder="How can we help?" /></label>
        <label className="contact-honeypot" aria-hidden="true">Website<input name="website" tabIndex={-1} autoComplete="off" /></label>
        <button className="button" type="submit" disabled={submitState==='sending'}>{submitState==='sending'?'Sending…':'Send message'}</button>
        {feedback&&<p className="form-note" role={submitState==='error'?'alert':'status'} aria-live="polite">{feedback}</p>}
      </form>
      <aside className="feature-panel contact-side"><Eyebrow>Semantic Secured</Eyebrow><h2>Research and product enquiries stay distinct.</h2><p className="muted">Use the topic field so research discussions can be routed separately from Conseqra platform or commercial conversations.</p><p className="muted">Prefer email? Write to <a href="mailto:contact@semanticsecured.com">contact@semanticsecured.com</a>.</p></aside>
    </section>
  </>
}
